import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_382: DocMigration = {
  maxSchemaVersion: "0.0.382",
  description: "Unify dormer truncation parameters",
  apply(json: any) {
    const { dormers = {} } = json;
    for (const dormerId in dormers) {
      const dormer = dormers[dormerId];
      const { truncationOptions } = dormer;

      if (!truncationOptions) {
        continue;
      }

      dormer.truncationType = truncationOptions.type;
      dormer.truncationHeightFactor = truncationOptions.heightFactor;
      dormer.truncationNormalizedHeight = truncationOptions.normalizedHeight;
      dormer.truncationSlopeType = truncationOptions.slopeType;
      dormer.truncationSlope = truncationOptions.slope;

      delete dormer.truncationOptions;
    }
    return json;
  },
};

export default migration_0_0_382;
